<template>
  <div class="messageItem">
    <div class="messageItemView">
        <!-- 头像 -->
      <div
        class="messageItemView__avatar"
        :style="{ backgroundImage:`url(${getImg(dic.sender.avatar)})` }"
        @click="jumpToProfile()"
      ></div>
      <div class="messageItemView__rightWrapper">
        <!-- 消息的产生行为 -->
        <label class="messageItemView__name" @click="jumpToProfile()">{{dic.sender.name}}</label>
        <label class="messageItemView__time">{{dic.create_time}}</label>

        <p class="messageItemView__content" v-if="dic.types==='like_post'">赞了{{ownerInfo.owner===dic.owner.user?"你的":dic.owner.name}}的帖子</p>
        <p class="messageItemView__content" v-else-if="dic.types==='like_comment'">赞了{{ownerInfo.owner===dic.owner.user?"你的":dic.owner.name}}的评论</p>
        <p class="messageItemView__content" v-else-if="dic.types==='like_reply'">赞了{{ownerInfo.owner===dic.owner.user?"你的":dic.owner.name}}的回复</p>
        <p class="messageItemView__content" v-else-if="dic.types==='create_comment' || dic.types==='attention_comment' || dic.types === 'attention_reply' " v-html="escape(dic.record_data && dic.record_data.content)"></p>
        <p class="messageItemView__content" v-else-if="dic.types==='create_reply'">
          回复
          <span class="messageItemView__content__highlight">@{{dic.owner.name}}</span>
          :
          <span v-html="escape(dic.record_data && dic.record_data.content)" class="messageItemView__content--max"></span>
        </p>
        <p class="messageItemView__content" v-else-if="dic.types==='notification'" v-html="dic.content">{{dic.content}}</p>


        <!-- 消息原始来源 -->
        <div class="messageItemView__content_record" v-if="message_types.includes(dic.types)">
            <template v-if="dic.record_data">
            <p class="messageItemView__content_record__text" v-if="dic.types==='like_post'" @click="goPostDetail(dic.record_data.pk)">
                <span class="messageItemView__content_record__text__label"></span>
                <span class="messageItemView__content__highlight">@{{dic.record_data.owner.name}}</span>
                :
                <span class="messageItemView__content--max" v-html="escape(dic.record_data.content)"></span>
            </p>
            <p class="messageItemView__content_record__text" v-if="dic.types==='like_comment'" @click="goPostDetail(dic.record_data.post.pk)">
                <span class="messageItemView__content_record__text__label"></span>
                <span class="messageItemView__content__highlight">@{{dic.record_data.owner.name}}</span>
                :
                <span class="messageItemView__content--max" v-html="escape(dic.record_data.content)"></span>
            </p>
            <p class="messageItemView__content_record__text" v-if="dic.types==='like_reply'" @click="goPostDetail(dic.record_data.comment.post.pk)">
                <span class="messageItemView__content_record__text__label"></span>
                <span class="messageItemView__content__highlight">@{{dic.record_data.owner.name}}</span>
                :
                <span class="messageItemView__content--max" v-html="escape(dic.record_data.content)"></span>
            </p>
            <p class="messageItemView__content_record__text" v-if="dic.types==='create_comment' || dic.types==='attention_comment'" @click="goPostDetail(dic.record_data.post.pk)">
                <span class="messageItemView__content_record__text__label">评论{{ownerInfo.owner===dic.record_data.post.owner.user?"我":dic.record_data.post.owner.name}}的社区：</span>
                <span class="messageItemView__content--max" v-html="escape(dic.record_data.post.content)"></span>
            </p>
             <p class="messageItemView__content_record__text" v-if="dic.types==='create_reply' || dic.types==='attention_reply'" @click="goPostDetail(dic.record_data.comment.post.pk)">
                <span class="messageItemView__content_record__text__label">回复{{ownerInfo.owner===dic.record_data.reply_user.user?"我":dic.record_data.reply_user.name}}的评论：</span>
                <span>@{{dic.record_data.reply_user.name}}</span>
                :
                <span class="messageItemView__content--max" v-html="escape(dic.record_data.comment.content)"></span>
            </p>
            </template>
            <template v-else>
                <p class="messageItemView__content_record__text">抱歉，此记录已被删除</p>
            </template>
        </div>
      </div>
    </div>
    <!-- 按钮区 -->
    <div class="messageItemHandles" v-if="dic.sender.user !== ownerInfo.owner && source==='comment' && dic.record_data">
        <div class="messageItemHandle messageItemHandle--comment" @click="openInputEvent()">
            <img class="messageItemHandle__icon" :src="images.comment" />
            <span class="messageItemHandle__num">回复</span>
        </div>
        
        <template v-if="dic.types === 'create_comment' || dic.types==='create_reply' || dic.types === 'attention_comment' || dic.types==='attention_reply'">
            <span class="messageItemHandle__line"></span>
            <div class="messageItemHandle messageItemHandle--like" @click="likeEvent(dic.record_data.is_like)">
                <img class="messageItemHandle__icon" :src="dic.record_data.is_like?images.zan_select:images.zan_unselect" />
                <span class="messageItemHandle__num">{{dic.record_data.like_count === 0?"赞":dic.record_data.like_count}}</span>
            </div>
        </template>
    </div>
    <!-- 输入区 -->
    <div class="inputSuperView" v-if="openInput"><InputView type="reply" :placeholder="`回复@${dic.record_data.owner.name}:`" /></div>
    <!-- 删除区 -->
    <span class="messageItem__delete" v-if="dic.sender.user === ownerInfo.owner && !dic.types.includes('attention')" @click="deleteEvent()">x</span>
  </div>
</template>
<script>
import {
  IMG_COMMENT,
  IMG_ZAN_UNSELECT,
  IMG_ZAN_SELECT
} from "../../assets";
import {Utils} from '../../utils';

import InputView from "./InputView.vue";

export default {
  name: "MessageItem",
  components: {
    InputView
  },
  props: {
    dic: {
      type: Object
    },
    username:{
        type:String
    },
    ownerInfo: {
      type: Object
    },
    source:{
      type:String,
      default:'comment'
    }
  },
  data() {
    return {
        images: {
            comment: IMG_COMMENT,
            zan_unselect: IMG_ZAN_UNSELECT,
            zan_select: IMG_ZAN_SELECT,
        },
        message_types:['create_comment', 'create_reply', 'like_post', 'like_comment', 'like_reply', 'attention_comment', 'attention_reply'],
        openInput: false,
    };
  },
  computed: {},
  methods: {
    ...Utils,
      openInputEvent(){
          this.openInput = !this.openInput;
      },
    //点赞事件
    likeEvent(is_like) {
      let data = { pk: this.dic.record_data.pk, is_like: is_like };
      let type = ''
      if(this.dic.types === "create_comment" || this.dic.types === 'attention_comment'){
          //点赞评论
          type = 'comment'
      }else if(this.dic.types === "create_reply" || this.dic.types === 'attention_reply'){
          //点赞回复
          type = 'reply'
      }
      if (this.$parent.likeEvent && type !== '') {
        this.$parent.likeEvent(type, data);
      }
    },
    //删除事件
    deleteEvent(){
      if (this.$parent.deleteEvent) {
        this.$parent.deleteEvent(this.dic.pk);
      }
    },
    // 去到帖子详情页
    goPostDetail(post_pk){
      this.$router.push(`/mobilepost/${post_pk}`);
    },
    //跳到个人主页
    jumpToProfile(){
      let user_id = this.dic.sender.user_id;
      this.$router.push(`/profile/${user_id}`);
    },
    
    //--------inputView 组件的回调函数
    //对评论回复 或者 对回复的回复
    publish(type, data) {
        if(this.dic.types === "create_comment" || this.dic.types === "attention_comment"){
            //对评论进行回复
            data["comment"] = this.dic.record_data.pk
        }else if(this.dic.types === "create_reply" || this.dic.types === "attention_reply"){
            //对回复进行回复
            data["comment"] = this.dic.record_data.comment.pk
        }
      data["reply_user"] = this.dic.record_data.owner.user;
      this.openInput = !this.openInput;
      if (this.$parent.publish) {
        this.$parent.publish(type, data);
      }
    }
  },
  create() {},
  mounted() {}
};
</script>

<style scoped>
.messageItem {
  width: 100%;
  background-color: #ffffff;
  margin-bottom: 10px;
  position: relative;
}
.messageItemView {
  padding: 10px 15px;
  width: calc(100% - 30px);
  /* background-color: orange; */
  /* margin-bottom: 10px; */

  display: flex;
  flex-direction: row;
}
.messageItemView__avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
  /* background-color: red; */
  margin-right: 10px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  cursor: pointer;
}
.messageItemView__rightWrapper {
  display: flex;
  flex-direction: column;
  flex:1;
}
.messageItemView__name {
  font-weight: 700;
  font-size: 12px;
  margin-bottom: 7px;
  margin: 0 0 3px;
  padding: 5px 0 0;
  cursor: pointer;
}
.messageItemView__name:hover {
  color: #eb7350;
}
.messageItemView__time {
  margin-bottom: 2px;
  color: #808080;
  font-size: 12px;
}
.messageItemView__content {
  margin-bottom: 2px;
  padding: 1px 0 3px;
  line-height: 23px;
  word-wrap: break-word;
  word-break: break-word;
  font-size: 12px;
}
.messageItemView__content--max{
  /* line-height: 20px;
  max-height: 40px;
  overflow: hidden;
  display: inline-block; */
  word-wrap: break-word;
  word-break: break-word;
}
.messageItemView__content__highlight{
    color:#eb7350;
}
.messageItemView__content_record{
    padding: 5px 16px;
    margin: 0 0 10px;
    background-color: #f2f2f5;
}
.messageItemView__content_record__text{
  line-height: 23px;
  word-wrap: break-word;
  font-size: 12px;
  color: #333;
  word-break: break-all;
  max-height: 46px;
  overflow: hidden;
  cursor: pointer;
}
.messageItemView__content_record__text__label{
    color: #808080;
}
.messageItemHandles {
  width: 100%;
  height: 40px;
  border-top: solid 1px #f2f2f5;

  display: flex;
flex-direction: row;
align-items: center;
justify-content: center;
}
.messageItemHandle__line{
    width: 1px;
    height: 25px;
    background-color: #d9d9d9;
}
.messageItemHandle {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 30px;
  cursor: pointer;
  flex:1;
  justify-content: center;
}
.messageItemHandle__icon {
  /* width: 20px; */
  height: 15px;
  /* height: 20px; */
  /* background-color: red; */
  margin-right: 7px;
}
.messageItemHandle__num {
  font-size: 12px;
  color: #808080;
}
.messageItemHandle--like {
}
.messageItemHandle--comment {
}
.messageItem__delete{
    position: absolute;
    top: 0;
    right: 0;

    font-family: "wbficonregular" !important;
    display: inline-block;
    -webkit-font-smoothing: antialiased;
        width: 41px;
    height: 16px;
    padding: 4px 0 6px 0;
    text-align: center;
    font-size: 18px;
    color: #696e78;
    cursor: pointer;
}
.inputSuperView{
    padding: 16px 20px 6px;
    background-color: #f2f2f5;
}

</style>